import { inject, Injectable } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';
import { LayoutService } from '../layout.service';

@Injectable()
export class SysUtilService {

    private sidebarService: NbSidebarService = inject(NbSidebarService);
    private layoutService: LayoutService = inject(LayoutService);

    toggleSidebar(): void {
        this.sidebarService.toggle(true, 'menu-sidebar');
        this.layoutService.changeLayoutSize();
    }

    compactSidebar(): void {
        this.sidebarService.compact('menu-sidebar');
        this.layoutService.changeLayoutSize();
    }

    getSysrefCodeMajorGroup(sysrefCode: string): string {
        let pos = sysrefCode.length - 6;
        return sysrefCode.substring(pos, pos + 2);
    }

    getUacsMajorGroup(uacs: string): string {
        return uacs.substring(1, 3);
    }

    getAllotmentClass(descriptionFunction: Array<any> = [], allotmentClass: Array<any>, pap_description: number, fund: string = undefined): Array<any> {
        let selected_fund = descriptionFunction.filter((item: any) => item.fnd_id == pap_description);
        const n = ["60", "70", "98", "99"];
        let allotment_class = allotmentClass.filter((item: any) => !n.includes(item.major_group));
        if (fund != undefined && fund == "IGP") {
            allotment_class = allotmentClass.filter((item: any) => !n.filter((mg) => !["70"].includes(mg)).includes(item.major_group));
        } else if (selected_fund.length > 0) {
            // if (this.getSysrefCodeMajorGroup(selected_fund[0].fnd_sysref_code) == "02") {
            allotment_class = allotmentClass.filter((item: any) => !n.filter((mg) => mg != "70").includes(item.major_group));
            // }

            // if (selected_fund[0].fnd_sysref_code == "164010101") {
            //     allotment_class = allotmentClass.filter((item: any) => !n.filter((mg) => mg != "70").includes(item.major_group));
            // }
            // research services
            if (selected_fund[0].fnd_sysref_code == "164010200") {
                allotment_class = allotmentClass.filter((item: any) => !n.filter((mg) => !["70", "98"].includes(mg)).includes(item.major_group));
            }
            // extension services
            if (selected_fund[0].fnd_sysref_code == "164010300") {
                allotment_class = allotmentClass.filter((item: any) => !n.filter((mg) => !["70", "99"].includes(mg)).includes(item.major_group));
            }
            // mandatory reserve fund
            if (selected_fund[0].fnd_sysref_code == "164010500") {
                allotment_class = allotmentClass.filter((item: any) => item.major_group == "60" || item.major_group == "70");
            }
            // reserve fund 
            if (selected_fund[0].fnd_sysref_code == "164010800") {
                allotment_class = allotmentClass.filter((item: any) => item.major_group == "70");
            }
        }

        return allotment_class;
    }

    getYearRange(): Array<number> {
        let data: Array<number> = [];
        let date = new Date();
        let year = date.getFullYear();

        for (let y = year - 5; y <= (year + 6); y++) {
            data.push(y);
        }
        return data;
    }

    async getBase64ImageFromUrl(imageUrl) {
        var res = await fetch(imageUrl);
        var blob = await res.blob();

        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.addEventListener("load", function () {
                resolve(reader.result);
            }, false);

            reader.onerror = () => {
                return reject(this);
            };
            reader.readAsDataURL(blob);
        })
    }

    getSysRefCode(code: string | any) {
        const searchVal = ["-SB", "-CB"];
        const rgx = new RegExp(searchVal.join("|"), "gi");
        return code.replaceAll(rgx, "");
    }

}
